import React from 'react';
import { Box, Chip, makeStyles } from '@material-ui/core';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import useCurrentFive9Call from 'src/hooks/five9/useCurrentFive9Call';
import useFive9IntegrationEnabled from 'src/hooks/five9/useFive9IntegrationEnabled';
import useIsFive9ActiveInTab from 'src/hooks/five9/useIsFive9ActiveInTab';
import getCallDisplayNumber, { isCallInWrapUp } from 'src/utils/five9/getCallDisplayNumber';
import formatters from 'src/utils/formatters';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2)
  },
  chip: {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    marginRight: theme.spacing(1),
    '& .MuiChip-icon': {
      color: theme.palette.common.white
    }
  }
}));

/**
 * TopBar presence indicator for the agent's current Five9 call, visible on
 * every page so a call stays visible while the agent searches existing
 * dispatches. Display-only: the "Link Call" action lives in the dispatch
 * details header (AssociateCallToDispatch).
 */
function Five9ActiveCallChip() {
  const classes = useStyles();
  const isFive9Enabled = useFive9IntegrationEnabled();
  // Redux call state syncs across tabs; only the adapter's owner tab may act.
  const isFive9ActiveInTab = useIsFive9ActiveInTab();
  const { activeCall } = useCurrentFive9Call();

  if (!isFive9Enabled || !isFive9ActiveInTab || !activeCall) return null;

  const number = getCallDisplayNumber(activeCall);
  const display = number
    ? formatters.formatTelephoneNumber(number)
    : 'Call in progress';
  const label = isCallInWrapUp(activeCall) ? `${display} — wrap-up` : display;

  return (
    <Box className={classes.root} data-cy="five9-active-call-chip">
      <Chip
        icon={<PhoneInTalkIcon />}
        label={label}
        variant="outlined"
        size="small"
        className={classes.chip}
      />
    </Box>
  );
}

export default Five9ActiveCallChip;
